// We can attempt to automatically get `.webp` support by appending `f_auto` onto image URLs
// We cannot add this to the default transform, which is why we perform the URL check/swap here
// We also avoid adding this onto SVGs so it doesn't rasterize them
// @NOTE https://cloudinary.com/blog/transparent_webp_format_cdn_delivery_based_on_visitors_browsers
export default function cloudinaryTransform(src) {
  const url = !src.includes('.svg')
    ? src.replace('t_default', 't_default,f_auto')
    : src

  return url
}
